module.exports = __webpack_public_path__ + "img/image140.90b4bb13.jpg";